import React from 'react'
import SectionType from 'models/types/ts/sectionType'
import { CountDown } from 'features/count-down'
import style from "./DlpCountDown.module.scss"


interface Props {
    section: SectionType
}


export const DlpCountDown = ({ section: { headline, date } }: Props): JSX.Element => {
    if (new Date() > new Date(date)) {
        return
    }
    return <div className={style.sectionWrapper}>
        <div className={style.countDownWrapper}>        
            <CountDown date={String(date)} title={headline} />
        </div>
    </div>
} 